import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/auth/auth.service';
import { RestService } from 'src/providers/rest.service';
const moment = require('moment')

@Component({
    selector: 'app-rota-gecmis',
    templateUrl: './rota-gecmis.component.html',
    styleUrls: ['./rota-gecmis.component.css']
})

export class RotaGecmisComponent implements OnInit {

    id:string="0"
    private subscriptions: Subscription[] = []
    rotaGecmis: any = [];

    constructor(private restService: RestService, 
        private authService: AuthService,
        private route: ActivatedRoute,
        private router: Router){

    }

    ngOnInit(): void {
        this.subscriptions.push(this.route.queryParams.subscribe(params => {
            this.id = params.id;
      
            if (!params.id) { this.id = '0'; }
      
            if (this.id !== '0') {
                this.restService.getRotaGecmis(this.id).subscribe(res => {
                    this.rotaGecmis = res;
                }, err => {
                    console.log(err);
                });
            }
          }));
    }

    convertDate(date):string{
        return moment(date).locale('tr').format('DD.MM.yyyy hh:mm')
    }
}